import type { RawFrame, RawCuboid, Cuboid, Frame } from './types';

const BASE_URL = 'https://static.scale.com/uploads/pandaset-challenge';

/** Total frames available in the challenge bucket (frame_00 … frame_49). */
export const FRAME_COUNT = 50;

/** Build the URL for a zero-padded frame index (0 → frame_00.json). */
export function frameUrl(index: number): string {
  return `${BASE_URL}/frame_${String(index).padStart(2, '0')}.json`;
}

function normalizeCuboid(c: RawCuboid): Cuboid {
  return {
    uuid: c.uuid,
    label: c.label,
    yaw: c.yaw,
    stationary: c.stationary,
    position: [c['position.x'], c['position.y'], c['position.z']],
    dimensions: [c['dimensions.x'], c['dimensions.y'], c['dimensions.z']],
  };
}

/**
 * Fetch and parse a single frame into render-ready buffers.
 */
export async function loadFrame(index: number, signal?: AbortSignal): Promise<Frame> {
  const res = await fetch(frameUrl(index), { signal });
  if (!res.ok) {
    throw new Error(`Failed to load frame ${index}: HTTP ${res.status}`);
  }
  const raw = (await res.json()) as RawFrame;

  const count = raw.points.length;
  const positions = new Float32Array(count * 3);
  for (let i = 0; i < count; i++) {
    const p = raw.points[i];
    positions[i * 3] = p[0];
    positions[i * 3 + 1] = p[1];
    positions[i * 3 + 2] = p[2];
  }

  return {
    id: raw.frame_id,
    positions,
    pointCount: count,
    cuboids: raw.cuboids.map(normalizeCuboid),
  };
}
